export default __webpack_public_path__ + "static/media/tiktok.51111cc4.png";